const CopyIcon = ({ onClick, color }) => {
  return (
    <svg
      width="19"
      height="20"
      viewBox="0 0 19 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      onClick={onClick}
      role="button"
    >
      <path
        d="M7.125 12.375C7.125 10.1358 7.125 9.01624 7.82062 8.32062C8.51624 7.625 9.63583 7.625 11.875 7.625L12.6667 7.625C14.9058 7.625 16.0254 7.625 16.721 8.32062C17.4167 9.01624 17.4167 10.1358 17.4167 12.375V13.1667C17.4167 15.4058 17.4167 16.5254 16.721 17.221C16.0254 17.9167 14.9058 17.9167 12.6667 17.9167H11.875C9.63583 17.9167 8.51624 17.9167 7.82062 17.221C7.125 16.5254 7.125 15.4058 7.125 13.1667L7.125 12.375Z"
        stroke={color ? color : "#828282"}
        stroke-width="1.1875"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M13.4582 7.62492C13.4564 5.28389 13.4209 4.07129 12.7395 3.24101C12.6079 3.08067 12.4609 2.93364 12.3006 2.80205C11.4247 2.08325 10.1234 2.08325 7.52081 2.08325C4.91822 2.08325 3.61693 2.08325 2.74107 2.80205C2.58073 2.93364 2.4337 3.08066 2.30211 3.24101C1.58331 4.11687 1.58331 5.41816 1.58331 8.02075C1.58331 10.6233 1.58331 11.9246 2.30211 12.8005C2.4337 12.9608 2.58073 13.1079 2.74107 13.2394C3.57135 13.9208 4.78395 13.9563 7.12498 13.9581"
        stroke={color ? color : "#828282"}
        stroke-width="1.1875"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export default CopyIcon;
